import { render, staticRenderFns } from "./SearchModalCompanies.vue?vue&type=template&id=66dfb98d&scoped=true"
import script from "./SearchModalCompanies.vue?vue&type=script&lang=js"
export * from "./SearchModalCompanies.vue?vue&type=script&lang=js"
import style0 from "./SearchModalCompanies.vue?vue&type=style&index=0&id=66dfb98d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dfb98d",
  null
  
)

export default component.exports